/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactTooltip from 'react-tooltip';
import ContractorChargebackTable from 'contractorChargebackTable';
import PropTypes from 'prop-types';
import { FontIcon, Checkbox } from 'react-toolbox';
import PurchaseOrderTable from './components/purchaseOrderTable';
import LaborSheetTable from './components/laborSheetTable';
import MerchandiseItemTable from 'phaseMerchandiseItemTable';
import contractorChargebackItemShape from 'types/contractorChargebackItem';
import purchaseOrderShape from 'types/purchaseOrder';
import LaborSheetType from 'types/laborSheet';
import phaseMerchandiseItem from 'types/phaseMerchandiseItem';
import { can } from '../../../../../../../services';
import { getRole } from '../../../../../../../reducers';
import { fetchPhaseDocuments, requestPhaseItems, requestEmployee } from 'actionCreators';
import documentType from 'types/documentUpload';
import S from './styles';
import proTip from 'images/pro-tip.png';
import LPATutorial from '../../../../../../../shared/components/SpotJoyride/LPATutorial';
import { vendorDisplayName } from '../../../../../../../utils';
import RTCheckbox from 'styles/checkbox.scss';
import styles from 'styles/form';

class AccountingWidget extends Component {
  constructor(props) {
    super(props);
    const tables = ['walkthrough', 'chargeback', 'laborsheet', 'merchandise', 'purchase-order'];
    const lpaFocus = tables.find(ext => location.pathname.includes(ext));
    this.state = {
      // -When navigating to lpa tab without table path after '/', open all tables
      // -Including table in url navigates to and opens only that table
      showPurchaseOrderSection: this.determineStateProperty(lpaFocus, 'purchase-order'),
      showPOLineItems: this.determineStateProperty(lpaFocus, 'purchase-order'),
      showLaborSheetSection: this.determineStateProperty(lpaFocus, 'laborsheet'),
      showLaborSheetLineItems: this.determineStateProperty(lpaFocus, 'laborsheet'),
      showChargebackSection: this.determineStateProperty(lpaFocus, 'chargeback'),
      showMerchandiseSection: this.determineStateProperty(lpaFocus, 'merchandise'),
      runStep2LPATutorial: false,
      allTablesCollapsedBtn: this.determineStateProperty(lpaFocus, 'walkthrough'),
      filterLineItems: true,
    };
    this.doLPATutorialStep2 = this.doLPATutorialStep2.bind(this);
    this.purchaseOrderRef = React.createRef();
    this.laborSheetRef = React.createRef();
    this.merchandiseRef = React.createRef();
    this.chargebackRef = React.createRef();
  }

  componentWillMount = () => {
    this.props.fetchPhaseDocuments(this.props.phaseId);
    this.fetchContractorLineItems();
    this.fetchChargebackItems();
    this.fetchPurchaseOrders();
    this.fetchMerchandiseItems();
    this.fetchEmployeeData();
  }

  componentDidMount = () => {
    const tableNameInPathName = this.grabTableNameFromPathName();
    if (tableNameInPathName !== null) {
      if (location.pathname.includes('purchase-order')) this.focusTable('purchaseOrder');
      if (location.pathname.includes('laborsheet')) this.focusTable('laborSheet');
      if (location.pathname.includes('merchandise')) this.focusTable('merchandise');
      if (location.pathname.includes('chargeback')) this.focusTable('chargeback');
    } else this.startUrlPathCheckInterval();
  }

  componentDidUpdate = () => {
    const { showPurchaseOrderSection, showLaborSheetSection,
      showChargebackSection, showMerchandiseSection, allTablesCollapsedBtn } = this.state;
    const sections = [
      showPurchaseOrderSection,
      showLaborSheetSection,
      showChargebackSection,
      showMerchandiseSection,
    ];
    const anyOpened = sections.some(sect => sect);
    const allCollapsed = sections.every(sect => !sect);
    if (anyOpened && allTablesCollapsedBtn) this.setState({ allTablesCollapsedBtn: false });
    if (allCollapsed && !allTablesCollapsedBtn) this.setState({ allTablesCollapsedBtn: true });
  }

  componentWillUnmount = () => (window.myInterval !== undefined ?
    window.clearInterval(window.myInterval) : null);

  getRelevantTableItems = (tableName) => {
    let lineItemsArr;
    switch (tableName) {
      case 'purchaseOrder':
        lineItemsArr = this.props.purchaseOrders;
        break;
      case 'laborSheet':
        lineItemsArr = this.props.laborSheets;
        break;
      case 'merchandise':
        lineItemsArr = this.props.merchandiseItems;
        break;
      case 'chargeback':
        lineItemsArr = this.props.chargebackLineItems;
        break;
      default:
        lineItemsArr = [];
    }
    return lineItemsArr;
  }

  getTableCount = (tableName) => {
    const tableItems = this.getRelevantTableItems(tableName);
    let cbCount = 0;
    tableItems.forEach((cbli) => {
      if (cbli.id > 0) cbCount += 1;
    });
    return cbCount;
  }

  getTableRef = (tableName) => {
    let tableRef;
    switch (tableName) {
      case 'chargeback':
        tableRef = this.chargebackRef;
        break;
      case 'purchaseOrder':
        tableRef = this.purchaseOrderRef;
        break;
      case 'laborSheet':
        tableRef = this.laborSheetRef;
        break;
      case 'merchandise':
        tableRef = this.merchandiseRef;
        break;
      default:
        tableRef = null;
    }
    return tableRef;
  }

  descVendor = () => vendorDisplayName(this.props.phaseSource, this.props.workroomName);

  purchaseOrderDesc = () => `Money being paid to SPIG from ${this.descVendor()}`;
  laborSheetDesc = () => 'Money being paid to Sub-Contractor from SPIG';
  merchDesc = () => `Product sold to Customer by ${this.descVendor()}`;
  chargebackDesc = () => 'Money owed to SPIG from Sub-Contractor or In-House monies that will not be recouped';

  determineStateProperty = (lpaFocus, comparator) => (
    comparator === 'walkthrough' ? lpaFocus === 'walkthrough' : lpaFocus === comparator || !lpaFocus);

  grabTableNameFromPathName = () => {
    const tableNames = ['chargeback', 'purchase-order', 'laborsheet', 'merchandise'];
    const tableNameInPathName = tableNames.filter(name => location.pathname.includes(name));
    return tableNameInPathName[0] === undefined ? null : tableNameInPathName[0];
  }

  startUrlPathCheckInterval = () => {
    const currentPath = location.pathname;
    if (window.myInterval !== undefined) clearInterval(window.myInterval);
    window.myInterval = setInterval(() => {
      const tableName = this.grabTableNameFromPathName();
      const isWalkthrough = location.pathname.includes('walkthrough');
      if (currentPath !== location.pathname && tableName !== null) {
        this.focusTable(tableName);
        if (window.myInterval !== undefined) clearInterval(window.myInterval);
        window.history.pushState(null, null, currentPath);
        this.startUrlPathCheckInterval();
      }
      if (currentPath !== location.pathname && isWalkthrough) {
        this.handleTables(true);
        window.history.pushState(null, null, `/phases/${this.props.phaseId}/labor-product-accounting`);
      }
    }, 500);
  }

  handleTables = (forceClose = false) => {
    const { showPurchaseOrderSection, showLaborSheetSection,
            showChargebackSection, showMerchandiseSection } = this.state;
    const sections = [
      showPurchaseOrderSection,
      showLaborSheetSection,
      showChargebackSection,
      showMerchandiseSection,
    ];
    const anyOpened = sections.some(sect => sect);
    if (anyOpened || forceClose) {
      this.setState({
        showPurchaseOrderSection: false,
        showLaborSheetSection: false,
        showChargebackSection: false,
        showMerchandiseSection: false,
        showPOLineItems: false,
        showLaborSheetLineItems: false,
        allTablesCollapsedBtn: true,
      });
    } else if (this.state.allTablesCollapsedBtn) {
      this.setState({
        showPurchaseOrderSection: true,
        showLaborSheetSection: true,
        showChargebackSection: true,
        showMerchandiseSection: true,
        showPOLineItems: true,
        showLaborSheetLineItems: true,
        allTablesCollapsedBtn: false,
      });
    }
  }

  // eslint-disable-next-line consistent-return
  focusTable = (tableName) => {
    const tableRef = this.getTableRef(tableName);
    const tableHeaderOffset = 200;
    setTimeout(() => {
      window.scrollTo({
        left: 0,
        top: tableRef.current.offsetTop - tableHeaderOffset,
        behavior: 'smooth',
      });
    }, 200);

    switch (tableName) {
      case 'chargeback':
        this.setState({ showChargebackSection: true });
        break;
      case 'purchaseOrder':
        this.setState({ showPurchaseOrderSection: true });
        break;
      case 'laborSheet':
        this.setState({ showLaborSheetSection: true });
        break;
      case 'merchandise':
        this.setState({ showMerchandiseSection: true });
        break;
      default:
        return null;
    }
    window.history.pushState(null, null, `/phases/${this.props.phaseId}/labor-product-accounting`);
    this.startUrlPathCheckInterval();
  }

  doLPATutorialStep2 = (run = false) => this.setState({ runStep2LPATutorial: run });

  fetchEmployeeData = () => {
    const { employableId, employableType } = this.props;
    if (employableType === 'employee') this.props.requestEmployee(employableId);
  }

  fetchContractorLineItems = () => this.props.requestPhaseItems(this.props.phaseId, 'contractorLineItems');

  fetchChargebackItems = () => this.props.requestPhaseItems(this.props.phaseId, 'contractorChargebackItems');

  fetchPurchaseOrders = () => this.props.requestPhaseItems(this.props.phaseId, 'purchaseOrders');

  fetchMerchandiseItems = () => this.props.requestPhaseItems(this.props.phaseId, 'phaseMerchandiseItems');

  toggleSection = (section) => {
    const { showPurchaseOrderSection, showLaborSheetSection, showChargebackSection,
      showMerchandiseSection } = this.state;
    if (section === 'purchaseOrder') {
      if (showPurchaseOrderSection === false) this.toggleTableLineItems(section, false);
      this.setState({ showPurchaseOrderSection: !showPurchaseOrderSection });
    }
    if (section === 'laborSheet') {
      if (showLaborSheetSection === false) this.toggleTableLineItems(section, false);
      this.setState({ showLaborSheetSection: !showLaborSheetSection });
    }
    if (section === 'chargeback') this.setState({ showChargebackSection: !showChargebackSection });
    if (section === 'merchandise') this.setState({ showMerchandiseSection: !showMerchandiseSection });
  }

  toggleTableLineItems = (tableName, reset = null) => {
    const { showPOLineItems, showLaborSheetLineItems } = this.state;
    if (reset !== null) {
      if (tableName === 'purchaseOrder' && showPOLineItems !== reset) this.setState({ showPOLineItems: reset });
      if (tableName === 'laborSheet' && showLaborSheetLineItems !== reset) this.setState({ showLaborSheetLineItems: reset });
    } else {
      if (tableName === 'purchaseOrder') this.setState({ showPOLineItems: !showPOLineItems });
      if (tableName === 'laborSheet') this.setState({ showLaborSheetLineItems: !showLaborSheetLineItems });
    }
  }

  handleCheckboxChange = () => {
    const { filterLineItems } = this.state;
    if (!filterLineItems) this.setState({ filterLineItems: true });
    else this.setState({ filterLineItems: false });
  };

  displayCorrectTable = (tableName, showSection, permission) => {
    const { phaseId, documents, employableType, chargebackLineItems, purchaseOrders,
      laborSheets, merchandiseItems, phaseSource } = this.props;
    const { showPOLineItems, showLaborSheetLineItems, filterLineItems,
    } = this.state;
    const purchaseOrderSection = (permission && showSection) && <PurchaseOrderTable
      phaseId={phaseId}
      documents={documents}
      parentLineItems={purchaseOrders}
      showLineItems={showPOLineItems}
      toggleShowHide={this.toggleTableLineItems}
      tableName={tableName}
      expandableRow
      filterLineItems={filterLineItems}
    />;
    const laborSheetSection = (permission && showSection) && <LaborSheetTable
      phaseId={phaseId}
      documents={documents}
      refreshLineItemList={this.fetchContractorLineItems}
      employableType={employableType}
      lineItems={laborSheets}
      showLineItems={showLaborSheetLineItems}
      toggleShowHide={this.toggleTableLineItems}
      tableName={tableName}
      doLPATutorialStep2={this.doLPATutorialStep2}
      filterLineItems={filterLineItems}
    />;
    const merchSection = showSection && <MerchandiseItemTable
      phaseId={phaseId} parentLineItems={merchandiseItems} phaseSource={phaseSource}
    />;
    const chargebackSection = (permission && showSection) && <ContractorChargebackTable
      phaseId={phaseId}
      documents={documents}
      lineItems={chargebackLineItems}
      phaseSource={phaseSource}
    />;
    switch (tableName) {
      case 'purchaseOrder':
        return purchaseOrderSection;
      case 'laborSheet':
        return laborSheetSection;
      case 'merchandise':
        return merchSection;
      case 'chargeback':
        return chargebackSection;
      default:
        return null;
    }
  }

  toolTip = (tableName, tipDesc) => <div className={S.tooltip}>
    <button
      className={S.tooltipBtn}
      data-tip
      data-for={`${tableName}Tip`}
    >
      <img src={proTip} alt={'Pro Tip Icon'} className={S.tooltipImg} />
    </button>
    <ReactTooltip id={`${tableName}Tip`} place="top" effect="solid">
      <span className={S.tooltipText}>{tipDesc}</span>
    </ReactTooltip>
  </div>;

  renderHandleTablesBtn = (label, btnType) => <div className={S.collapseAllTablesBtn}>
    <FontIcon>{btnType}</FontIcon>
    <div>{label}</div>
    <FontIcon>{btnType}</FontIcon>
  </div>

  renderTable = (tableName, tableTitle, tipDesc, showSection,
                 showTableLineItems = false, permission = true) => {
    const tableCount = this.getTableCount(tableName);
    const tablesWithShowButton = ['purchaseOrder', 'laborSheet'];
    const tableRef = this.getTableRef(tableName);
    return (permission && <div
      id={`header_${tableName}`} // LPATutorial installerPayTutorial1
      className={showSection ? S.activeContainerStyles : S.InactiveContainerStyles}
      ref={tableRef}
      onClick={() => this.toggleSection(tableName)}
    >
      {(tableCount > 0 ? <div className={S.header}>{tableTitle}
        <div className={tableName === 'chargeback' ? S.redCount : S.greenCount}>{`(${tableCount})`}</div>
        {this.toolTip(tableName, tipDesc)}
      </div> : <div className={S.header}>
        <div>{tableTitle}</div>
        {this.toolTip(tableName, tipDesc)}
      </div>)}
      <div className={showSection ? S.content : ''} onClick={e => e.stopPropagation(e)}>
        {(tablesWithShowButton.includes(tableName) && showSection) && <div
          className={S.btnWrapper}
          onClick={e => e.stopPropagation(e)}
        >
          <button
            id={`showLIBtn_${tableName}`}
            className={S.showHideBtn}
            onClick={() => this.toggleTableLineItems(tableName)}
          >
            {!showTableLineItems ? 'SHOW Line Items' : 'HIDE Line Items'}
          </button>
        </div>}
        {this.displayCorrectTable(tableName, showSection, permission)}
        <div
          className={S.shelfBottom}
          onClick={() => this.toggleSection(tableName)}
        >
          <div className={showSection ? S.shelfBottomCollapse : S.shelfBottomExpand}>
            <FontIcon className={S.shelfBottomArrow}>{showSection ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}</FontIcon>
          </div>
        </div>
      </div>
    </div>
    );
  }

  render = () => {
    const { role } = this.props;
    const { showPurchaseOrderSection, showLaborSheetSection, showMerchandiseSection,
      showChargebackSection, showPOLineItems, showLaborSheetLineItems,
      runStep2LPATutorial, allTablesCollapsedBtn, filterLineItems } = this.state;
    return (<div>
      <Checkbox
        checked={filterLineItems}
        className={styles.purchaseOrdercheckbox}
        onChange={this.handleCheckboxChange}
        label="Filter Line Item Options By Phase Surface Type"
        theme={RTCheckbox} type="checkbox"
        styles={{ textAlign: 'center' }}
      />
      <button
        className={S.collapseAllTablesBtnContainer}
        onClick={() => this.handleTables()}
      >
        {allTablesCollapsedBtn ?
        this.renderHandleTablesBtn('Expand All Tables', 'keyboard_arrow_down') :
        this.renderHandleTablesBtn('Collapse All Tables', 'keyboard_arrow_up')}
      </button>
      <LPATutorial runStep2={runStep2LPATutorial} toggleStep2={this.doLPATutorialStep2} />
      <div id="installerPayTutorial0" className={S.layout}>
        {this.renderTable('purchaseOrder', 'PURCHASE ORDERS', this.purchaseOrderDesc(), showPurchaseOrderSection, showPOLineItems, can(role, 'view', 'purchase_order'))}
        {this.renderTable('laborSheet', 'LABOR SHEETS', this.laborSheetDesc(), showLaborSheetSection, showLaborSheetLineItems, can(role, 'view', 'labor_sheet'))}
        {this.renderTable('merchandise', 'MERCHANDISE', this.merchDesc(), showMerchandiseSection)}
        {this.renderTable('chargeback', 'CHARGEBACKS', this.chargebackDesc(), showChargebackSection, null, can(role, 'view', 'chargeback'))}
      </div>
    </div>);
  }
}

AccountingWidget.propTypes = {
  phaseId: PropTypes.string,
  phaseSource: PropTypes.string,
  workroomName: PropTypes.string,
  documents: PropTypes.arrayOf(documentType).isRequired,
  lineItems: PropTypes.arrayOf(
    PropTypes.shape(contractorChargebackItemShape),
  ),
  purchaseOrders: PropTypes.arrayOf(
    PropTypes.shape(purchaseOrderShape),
  ),
  laborSheets: PropTypes.arrayOf(LaborSheetType),
  merchandiseItems: PropTypes.arrayOf(
    PropTypes.shape(phaseMerchandiseItem),
  ),
  chargebackLineItems: PropTypes.arrayOf(
    PropTypes.shape(contractorChargebackItemShape),
  ),
  role: PropTypes.string.isRequired,
  employableId: PropTypes.number,
  employableType: PropTypes.string,
  fetchPhaseDocuments: PropTypes.func.isRequired,
  documentsLoaded: PropTypes.bool.isRequired,
  requestPhaseItems: PropTypes.func.isRequired,
  requestEmployee: PropTypes.func.isRequired,
};

export default connect(state => ({
  purchaseOrders: state.phase.purchaseOrders.items,
  laborSheets: state.phase.laborSheets.items,
  merchandiseItems: state.phase.phaseMerchandiseItems.items,
  chargebackLineItems: state.phase.contractorChargebackItems.items,
  documents: state.phase.documents.data,
  documentsLoaded: state.phase.documents.loaded,
  role: getRole(state),
  employableType: state.user.employable_type.toLowerCase(),
  employableId: state.user.employable_id,
  phaseSource: state.phase.details.source || '',
  workroomName: state.phase.details.workroom ?
    state.phase.details.workroom.name : null,

}), { fetchPhaseDocuments, requestPhaseItems, requestEmployee })(AccountingWidget);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseAccounting/index.jsx